import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import useStore, { selectFavoriteCountryId } from '@/hooks/client/useStore';

const css = {
  mainBox: {
    position: 'relative',
    width: '100vw',
    height: '100vh',
    overflow: 'hidden',
  },
  image: {
    position: 'absolute',
    top: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    height: '100vh',
    width: 'auto',
  },
};

/**
 * If device is desktop or width > 1200px (lg) the img saying incompatible device will be shown
 * @returns {JSX.Element}
 */
const IncompatibleScreen = ({ isLandscape = false }) => {
  const countryCode = useStore(selectFavoriteCountryId);
  return (
    <Box sx={css.mainBox}>
      <Box
        component="img"
        src={`/images/${countryCode}/desktop.jpg`}
        alt="Incompatible screen"
        sx={css.image}
      />
    </Box>
  );
};

IncompatibleScreen.propTypes = {
  isLandscape: PropTypes.bool,
};

export default IncompatibleScreen;
